import React from 'react';

import { IconPropTypes } from 'ggApp/types/propTypes';

const Sms = ({ color, size, className }) => (
    <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 18.8388L5.47669 17.6574C6.00863 17.2318 6.66957 17 7.35078 17H18C19.1046 17 20 16.1046 20 15V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V18.8388ZM6.72609 19.2191L3.6247 21.7002C2.96993 22.2241 2 21.7579 2 20.9194V7C2 4.79086 3.79086 3 6 3H18C20.2091 3 22 4.79086 22 7V15C22 17.2091 20.2091 19 18 19H7.35078C7.12371 19 6.9034 19.0773 6.72609 19.2191Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5 9.49962C14.5 8.6714 15.1714 8 15.9996 8C16.8564 8 17.4992 8.71463 17.4992 9.55C17.4992 9.82614 17.2754 10.05 16.9992 10.05C16.7231 10.05 16.4992 9.82614 16.4992 9.55C16.4992 9.26095 16.3107 9 15.9996 9C15.7237 9 15.5 9.22369 15.5 9.49962C15.5 10.063 16.0291 10.2057 16.4544 10.4184C17.0948 10.7387 17.4992 11.3933 17.4992 12.1093V12.5004C17.4992 13.3286 16.8278 14 15.9996 14C15.1714 14 14.5 13.3286 14.5 12.5004V12.25C14.5 11.9739 14.7239 11.75 15 11.75C15.2761 11.75 15.5 11.9739 15.5 12.25V12.5004C15.5 12.7763 15.7237 13 15.9996 13C16.2756 13 16.4992 12.7763 16.4992 12.5004V12.1093C16.4992 11.772 16.3087 11.4637 16.007 11.3128C15.2193 10.9188 14.5 10.5102 14.5 9.49962Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 10.4465V13.4999C11 13.776 10.7761 13.9999 10.5 13.9999C10.2239 13.9999 10 13.776 10 13.4999V8.50379C10 7.98593 10.6902 7.80817 10.94 8.26235L11.9995 10.1888L13.0567 8.26274C13.3062 7.80819 13.9969 7.98564 13.9969 8.5038V13.4999C13.9969 13.776 13.773 13.9999 13.4969 13.9999C13.2207 13.9999 12.9969 13.776 12.9969 13.4999V10.4501L12.5259 11.3082C12.2982 11.7231 11.7022 11.7233 11.4742 11.3087L11 10.4465Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.85671 8 9.5 8.71456 9.5 9.55C9.5 9.82614 9.27614 10.05 9 10.05C8.72386 10.05 8.5 9.82614 8.5 9.55C8.5 9.26086 8.31097 9 8 9C7.72386 9 7.5 9.22386 7.5 9.5C7.5 10.0632 8.02982 10.2059 8.45492 10.4184C9.09541 10.7387 9.5 11.3933 9.5 12.1094V12.5C9.5 13.3284 8.82843 14 8 14C7.17157 14 6.5 13.3284 6.5 12.5V12.25C6.5 11.9739 6.72386 11.75 7 11.75C7.27614 11.75 7.5 11.9739 7.5 12.25V12.5C7.5 12.7761 7.72386 13 8 13C8.27614 13 8.5 12.7761 8.5 12.5V12.1094C8.5 11.7721 8.30941 11.4637 8.0077 11.3129C7.22002 10.919 6.5 10.5107 6.5 9.5Z"
            fill={color}
        />
    </svg>
);

Sms.propTypes = {
    ...IconPropTypes,
};

Sms.defaultProps = {
    color: '#333333',
    size: '24px',
};

export default Sms;
